export default __webpack_public_path__ + "assets/f3208688419231506e281fc809a30b72.svg";